<script lang="ts">
  import { penalty } from '../../board/Board.svelte';

  import { gaugeStarIn, gaugeStarOut } from '~/animations.svelte';
  import Star from '../../icons/Star.svelte';

  type Props = {
    radius: number;
    stars: number;
    starSize: number;
  };
  const props: Props = $props();
  const starGap = $derived(4 / props.radius);

  const getStarRotation = (position: number) =>
    // `rotate(${360 * starGap * (position - (numStars - 1) / 2)}deg)`
    `rotate(${360 * starGap * position}deg)`;

  const getInvRotation = (numStars: number) =>
    `rotate(${(-360 * starGap * (numStars - 1)) / 2}deg)`;
</script>

<div
  class="stars"
  style="
    transform-origin: {props.radius}px {props.radius}px;
    transform: {getInvRotation(props.stars)};
    transition: transform 0.2s ease;
  "
>
  {#each Array.from({ length: props.stars }) as star, i (i)}
    <div
      class="star-container"
      data-id={i}
      in:gaugeStarIn
      out:gaugeStarOut
      style="
        width: {2 * props.radius}px;
        height: {2 * props.radius}px;
        transform: {getStarRotation(i)};
      "
    >
      <Star
        size={props.starSize}
        penalty={i >= props.stars - penalty.current}
        outlined
      />
    </div>
  {/each}
</div>

<style lang="scss">
  .stars {
    position: absolute;
    top: 0;
    left: 0;
  }
  .star-container {
    transition: transform 0.1s ease;
    position: absolute;
  }
</style>
